module.exports = __webpack_public_path__ + "static/media/brand.e681e49a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/pins/brand.svg
// module id = 1951
// module chunks = 0